import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getFetchSujets } from '@api'
import { sanitizeStep, sanitizeStepsFinished } from '@store/steps'
import {
  FETCH_STATUS_ERROR,
  FETCH_STATUS_IDLE,
  FETCH_STATUS_PENDING,
} from '@config/constants'
import { postUploadSujet } from '@api/'

const initialState = {
  sujets: false,
  fetchStatus: false,
  currentStep: 0,
  stepsFinished: -1,
  lang: false,
  selectedSujet: false,
  serializedFile: false,
  compositeImages: false,
  stateComposition: false,
  compositeError: false,
}

export const actionFetchSujets = createAsyncThunk(
  'app/fetchSujets',
  async () => {
    return await getFetchSujets()
  }
)
export const actionPostUpload = createAsyncThunk(
  'app/postUpload',
  async ({ sujetId, base64Str, type }) => {
    return await postUploadSujet(sujetId, base64Str, type)
  }
)

export const AppReducer = createSlice({
  name: 'app',
  initialState,
  reducers: {
    init: (state) => state,
    actionSetStep: (state, action) => {
      state.currentStep = sanitizeStep(action.payload)
      state.stepsFinished = sanitizeStepsFinished(
        action.payload,
        state.stepsFinished
      )
    },

    actionSetStepsFinishedManually: (state, action) => {
      state.stepsFinished = action.payload
    },

    actionSetLanguage: (state, action) => {
      state.lang = action.payload
    },
    actionSetSujet: (state, action) => {
      state.selectedSujet = action.payload
    },
    actionSetSerializedFile: (state, action) => {
      state.serializedFile = action.payload
    },
    actionSetCompositeImages: (state, action) => {
      state.compositeImages = action.payload
    },
    actionResetCompositeUpload: (state) => {
      state.compositeImages = false
      state.stateComposition = false
      state.compositeError = false
    },
    actionResetCompositeUploadState: (state) => {
      state.stateComposition = false
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionFetchSujets.pending, (state) => {
        state.comp = false
        state.fetchStatus = FETCH_STATUS_PENDING
      })
      .addCase(actionFetchSujets.fulfilled, (state, action) => {
        state.sujets = action.payload
        state.fetchStatus = FETCH_STATUS_IDLE
      })
      .addCase(actionFetchSujets.rejected, (state) => {
        state.sujets = false
        state.fetchStatus = FETCH_STATUS_ERROR
      })
      .addCase(actionPostUpload.pending, (state) => {
        state.compositeImages = false
        state.stateComposition = FETCH_STATUS_PENDING
        state.compositeError = false
      })
      .addCase(actionPostUpload.fulfilled, (state, action) => {
        state.compositeImages = action.payload
        state.stateComposition = FETCH_STATUS_IDLE
        state.compositeError = false
      })
      .addCase(actionPostUpload.rejected, (state, action) => {
        state.compositeImages = false
        state.stateComposition = FETCH_STATUS_ERROR
        state.compositeError = action.error.message
      })
  },
})

export const {
  init,
  actionSetStep,
  actionSetLanguage,
  actionSetStepsFinishedManually,
  actionSetSujet,
  actionSetSerializedFile,
  actionSetCompositeImages,
  actionResetCompositeUpload,
  actionResetCompositeUploadState,
} = AppReducer.actions
export default AppReducer.reducer
